module.exports = __webpack_public_path__ + "img/xinzhi.6ffd89c0.png";